import { render, staticRenderFns } from "./BrIntroduction.vue?vue&type=template&id=b259b068&scoped=true"
import script from "./BrIntroduction.vue?vue&type=script&lang=js"
export * from "./BrIntroduction.vue?vue&type=script&lang=js"
import style0 from "./BrIntroduction.vue?vue&type=style&index=0&id=b259b068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b259b068",
  null
  
)

export default component.exports